import { GlobalState } from '../../reducers';

export const getRefreshToken = (state: GlobalState) =>
  state?.auth?.refreshToken;
